import React from 'react';

import img1 from '../assests/img/partner-3.jpg';
import img2 from '../assests/img/partner-4.jpg';
import img3 from '../assests/img/partner-5.jpg';
import img4 from '../assests/img/partner-6.jpg';
import img5 from '../assests/img/partner-7.jpg';
import img6 from '../assests/img/partner-8.jpg';
import img7 from '../assests/img/partner-9.jpg';





function Partners() {
  return (
    <>
     
      <section className="show-activity partner-sec">

        <div className='sec-title'>
          <h2>Associate Partners</h2>
          <div class="separator"></div>
        </div>

        <div className="container-fluid">
          <div className="row-inner">
            <div className='gallery-box'>
              <img src={img1}/>
            </div>
            <div className='gallery-box'>
              <img src={img2}/>
            </div>
            <div className='gallery-box'>
              <img src={img3}/>
            </div>
            <div className='gallery-box'>
              <img src={img4}/>
            </div>
            <div className='gallery-box'>
              <img src={img5}/>
            </div>
            <div className='gallery-box'>
              <img src={img6}/>
            </div>
            <div className='gallery-box'>
              <img src={img7}/>
            </div>
          </div>
        </div>
      </section>

    </>
  )

}

export default Partners;
